import React from 'react';

export const Header = (props) => <div className="canvas-header">{props.children}</div>;
export const Footer = (props) => <div className="canvas-footer">{props.children}</div>;
export const Sidebar = (props) => <div className="canvas-sidebar">{props.children}</div>;
export const ToolPanel = (props) => <div className="canvas-tool-panel">{props.children}</div>;
export const CanvasArea = (props) => <div className="canvas-area">{props.children}</div>;
export const SidePanel = (props) => <div className="canvas-side-panel">{props.children}</div>;
export const ReviewModal = (props) => props.isOpen ? <div className="canvas-review-modal">{props.children}</div> : null;
export const ImageDetailsModal = (props) => props.isOpen ? <div className="canvas-image-details-modal">{props.children}</div> : null;
export const UploadMenu = (props) => <div className="canvas-upload-menu">{props.children}</div>;
export const LoadingOverlay = (props) => props.isLoading ? <div className="canvas-loading-overlay">{props.children}</div> : null;
